import templateUrl from 'emun.salesrep/salesrep-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class SalesRepListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.query = $ctrl.container.query;
    }
    load() {
        const $ctrl = this;
        return $ctrl.query.load.apply($ctrl.query, arguments);
    }
}

export default {
    bindings: {
    },
    require: {
        container: '^salesrepContainer'
    },
    controller: SalesRepListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};